import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { SERVICES, scrollToId } from "../data/projects";

const enquire = (serviceId) => {
  window.dispatchEvent(new CustomEvent("preselect-service", { detail: serviceId }));
  scrollToId("contact");
};

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-copper">What we build</p>
        <div className="mt-4 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <h2 className="max-w-xl font-display text-4xl font-semibold tracking-tight text-cream sm:text-5xl">
            Four crafts. One architectural standard.
          </h2>
          <p className="max-w-sm text-sm leading-relaxed text-cream/60">
            Every discipline is delivered in-house by our own artisans — no
            hand-offs, no compromises, no finger-pointing.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
        {SERVICES.map((s, i) => (
          <Reveal
            key={s.id}
            delay={i * 0.08}
            className={i === 0 ? "lg:col-span-2 lg:row-span-2" : ""}
          >
            <article
              data-testid={`service-card-${s.id}`}
              className="group relative flex h-full min-h-[300px] flex-col justify-end overflow-hidden rounded-2xl border border-line bg-surface transition-transform duration-500 hover:-translate-y-1.5 lg:min-h-0"
            >
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-60 transition-all duration-700 ease-out group-hover:scale-105 group-hover:opacity-45"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
              <div className="relative flex flex-col gap-3 p-6 lg:p-8">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-copper">
                  0{i + 1} — {s.short}
                </p>
                <h3 className={`font-display font-semibold tracking-tight text-cream ${i === 0 ? "text-3xl lg:text-4xl" : "text-xl"}`}>
                  {s.title}
                </h3>
                <p className="max-w-md text-sm leading-relaxed text-cream/65">{s.description}</p>
                <button
                  data-testid={`service-enquire-${s.id}`}
                  onClick={() => enquire(s.id)}
                  className="mt-2 flex w-max items-center gap-2 rounded-full border border-cream/20 px-5 py-2.5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:border-copper hover:bg-copper hover:text-ink"
                >
                  Enquire <ArrowUpRight size={13} />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
